import { Route, Routes } from "react-router-dom";
import { Dashboard } from "./dashboard";
import { DashboardList } from "./dashboard-list";
import { Logo } from "../../styles/logos/ipg-logo";

export const ReportingBody = () => {
  return (
    <Routes>
      <Route path=":workspaceId">
        <Route index element={<DashboardList />}></Route>
        <Route path=":reportingId" element={<Dashboard />}></Route>
      </Route>
      <Route path="*" element={<NoWorkSpaceSelected />}></Route>
    </Routes>
  );
};

const NoWorkSpaceSelected = () => {
  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        flexDirection: "column",
        width: "100%",
        textAlign: "center",
        position: "relative",
        top: "38%",
      }}
    >
      <h1>WELCOME TO IPG MEDIABRANDS REPORTING</h1>
      <div style={{ display: "flex", justifyContent: "center" }}>
        <Logo />
      </div>
    </div>
  );
};
